import { render, staticRenderFns } from "./financialDetail.vue?vue&type=template&id=41207d68&scoped=true"
import script from "./financialDetail.vue?vue&type=script&lang=js"
export * from "./financialDetail.vue?vue&type=script&lang=js"
import style0 from "./financialDetail.vue?vue&type=style&index=0&id=41207d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41207d68",
  null
  
)

export default component.exports